export default {
  blog: {
    seo: {
      title: 'Blog',
      description:
        'Practical articles on last-mile delivery, fleet management, customer experience, and how leading teams use Geofleet for smarter delivery operations.',
    },
    badge: 'Blog',
    hero: {
      title: 'Insights for',
      titleHighlight: 'smarter delivery ops',
      description:
        'Practical articles on last-mile delivery, fleet management, customer experience, and how leading teams use Geofleet.',
    },
    filters: {
      categoryLabel: 'Category',
      allCategories: 'All Categories',
      searchLabel: 'Search articles by title',
      searchPlaceholder: 'Search articles...',
      all: 'All',
    },
    featured: {
      label: 'Featured article',
      readCta: 'Read article',
    },
    list: {
      latestTitle: 'Latest articles',
      title: 'Articles',
      showingInCategory: 'Showing {{count}} article in {{category}}',
      showingInCategory_other: 'Showing {{count}} articles in {{category}}',
      defaultSubtitle: 'Fresh perspectives on delivery, dispatch, and fleet operations',
      article_one: '{{count}} article',
      article_other: '{{count}} articles',
    },
    empty: {
      title: 'No articles match your search',
      hint: 'Try different keywords in the title search or choose another category.',
    },
    card: {
      readMore: 'Read more',
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
      pageOf: 'Page {{current}} of {{total}}',
    },
    cta: {
      title: 'Ready to improve your delivery ops?',
      subtitle: 'Get started in minutes. Plans from $49 a month for 3 drivers.',
    },
    post: {
      ogImageAlt: '{{title}} — Geofleet blog',
      backToBlog: 'Back to blog',
      updatedOn: 'Updated {{date}}',
      publishedOn: 'Published {{date}}',
      disclosure: 'Disclosure: this comparison is published by Geofleet, and we list our own product first. Every other product is described from its vendor’s public product and pricing pages, and each gets a fair “best for”.',
      pitch: {
        eyebrow: 'Try the #1 pick',
        title: 'Geofleet: from $49 a month for 3 drivers',
        text: 'Start on Geofleet Lite at $49 a month for 3 drivers and 500 orders, with route planning, live tracking, customer tracking links, proof of delivery and cash on delivery for one hub. Multi-hub teams move to Professional from $19 per driver per month, with branded tracking and AI agents on higher tiers.',
        startFree: 'Get started',
        bookDemo: 'Book a demo',
        caseStudy: 'Read the case study',
      },
      keyTakeaways: 'Key takeaways',
      tocAriaLabel: 'Table of contents',
      tocTitle: 'Contents',
      relatedTitle: 'Related articles',
      cta: {
        title: 'Explore the Geofleet command center',
        subtitle: 'See how AI agents can optimize your operations. Get started or book a walkthrough with our team.',
        bookDemo: 'Book a demo of Geofleet',
        aiAgentsLink: 'AI agents in Geofleet',
      },
    },
  },
};
